"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
require("leaflet.markercluster");
class InitializeOsm {
    constructor(container) {
        this.container = container;
    }
    create() {
        var _a;
        const id = (_a = this.container.getAttribute('data-js-map-id')) !== null && _a !== void 0 ? _a : "";
        const map = leaflet_1.default.map(`openstreetmap__map-${id}`, {
            scrollWheelZoom: false,
            keyboard: false,
            attributionControl: false,
        });
        const markers = leaflet_1.default.markerClusterGroup({
            showCoverageOnHover: false,
            removeOutsideVisibleBounds: true,
            maxClusterRadius: 50,
        });
        return [map, markers];
    }
}
exports.default = InitializeOsm;
